import React, { useState } from 'react';
import { Button, Avatar, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useMSALHelper } from '@/hooks/useMSALHelper';
import { useAdminModeAccess } from '@/hooks/useAdminModeAccess';
import { UserMenu } from './UserMenu';

export const AccountMenuButton = () => {
	const theme = useTheme();
	const [anchorEl, setAnchorEl] = useState(null);
	const { handleLogout } = useMSALHelper();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const brokerDetails = userDetails?.broker;
	const { isAdminMode } = useAdminModeAccess();

	const handleOpen = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	const handleSignOut = () => {
		handleClose();
		handleLogout();
	};

	return (
		<div>
			<Button
				variant='text'
				size='small'
				sx={{
					fontWeight: 700,
					fontSize: '1em',
					color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',
					textTransform: 'none',
				}}
				aria-controls='menu-appbar'
				aria-haspopup='true'
				aria-label={isAdminMode ? 'Account' : undefined}
				startIcon={
					brokerDetails?.imageUrl ? (
						<Avatar
							sx={{
								width: 24,
								height: 24,
								backgroundColor: '#34495E',
							}}
							src={brokerDetails?.imageUrl ?? ''}
						/>
					) : (
						<AccountCircle sx={{ fontSize: 24 }} />
					)
				}
				endIcon={isAdminMode ? undefined : <KeyboardArrowDownIcon />}
				onClick={handleOpen}
			>
				{isAdminMode ? '' : (brokerDetails?.name ?? '')}
			</Button>
			<UserMenu anchorEl={anchorEl} onClose={handleClose} onSignOut={handleSignOut} />
		</div>
	);
};
